import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.scss";

import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Multipage from "./pages/Multipage";
import OnemensAdmin from "./pages/OnemensAdmin";
import OnemensPengunjug from "./pages/OnemensPengunjung";
import PIT from "./pages/PIT";
import Cakazen from "./pages/Cakazen";
import PSB from "./pages/PSB";
import DKPPengunjung from "./pages/DKPPengunjung";
import DKPAdmin from "./pages/DKPAdmin";

import About from "./pages/About";
import Services from "./pages/Services";
import Resume from "./pages/Resume";
import Works from "./pages/Works";
import Certificates from "./pages/Certificates";
import Contact from "./pages/Contact";

import Demopage from "./pages/Demopage";
import WorkDetails from "./pages/WorkDetails";
import WorkDetails2 from "./pages/WorkDetails2";



function App() {
  const [darkMode, setDarkMode] = useState(
    () => window.localStorage.getItem("portfolio-theme") === "dark"
  );

  useEffect(() => {
    document.body.classList.toggle("dark-theme", darkMode);
    window.localStorage.setItem("portfolio-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <BrowserRouter>
      <button
        type="button"
        className="theme-toggle"
        onClick={() => setDarkMode((currentMode) => !currentMode)}
        aria-label={darkMode ? "Aktifkan mode terang" : "Aktifkan mode gelap"}
        title={darkMode ? "Aktifkan mode terang" : "Aktifkan mode gelap"}
      >
        <i className={`icon ${darkMode ? "icon-sun" : "icon-moon"}`} aria-hidden="true" />
        <span>{darkMode ? "Mode terang" : "Mode gelap"}</span>
      </button>
      <Switch>
        <Route path="/" component={Homepage} exact />
        <Route path="/multipage" component={Multipage} exact />
        <Route path="/blog/onemens-admin" component={OnemensAdmin} exact />
        <Route path="/blog/onemens-pengunjung" component={OnemensPengunjug} exact />
        <Route path="/blog/pit" component={PIT} exact />
        <Route path="/blog/cakazen" component={Cakazen} exact />
        <Route path="/blog/psb" component={PSB} exact />
        <Route path="/blog/dkp-pengunjung" component={DKPPengunjung} exact />
        <Route path="/blog/dkp-admin" component={DKPAdmin} exact />

        {/* For Multipage */}
        <Route path="/multipage" component={Multipage} exact />
        <Route path="/about" component={About} exact />
        <Route path="/services" component={Services} exact />
        <Route path="/resume" component={Resume} exact />
        <Route path="/works" component={Works} exact />
        <Route path="/certificates" component={Certificates} exact />
        <Route path="/works/:id/:title" component={WorkDetails} />
        <Route path="/work-details/:id/:title" component={WorkDetails2} />
        <Route path="/contact" component={Contact} exact />

        {/* Demo Purpose Only */}
        <Route path="/demopage" component={Demopage} exact />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
